<ng-container *ngIf="mode === backupMode.B2; else staticMode">
  <div class="fw-semibold">
    {{ 'wizards:onboarding.b2Title' | i18next }}
  </div>

  <div class="mt-3">
    <mbs-alert *ngIf="errorMessage"
               [type]="mbsPopupType.danger"
               [closable]="true"
               [icon]="true"
               (close)="removeError()">
      {{ errorMessage }}
    </mbs-alert>
  </div>

  <ng-container *ngIf="b2CredentialsForm">
    <form [formGroup]="b2CredentialsForm"
          class="mt-4">
      <mbs-form-group>
        <mbs-input formControlName="storageUnitName"
                   name="storageUnitName"
                   [label]="'wizards:onboarding.b2.bucketName' | i18next"
                   [readonly]="true"></mbs-input>
      </mbs-form-group>

      <mbs-form-group>
        <mbs-input formControlName="publicKey"
                   name="publicKey"
                   [label]="'wizards:onboarding.b2.publicKey' | i18next"
                   [validationWhitespace]="true"></mbs-input>
      </mbs-form-group>

      <mbs-form-group>
        <mbs-input formControlName="secretKey"
                   name="secretKey"
                   [label]="'wizards:onboarding.b2.secretKey' | i18next"
                   [validationWhitespace]="true"></mbs-input>
      </mbs-form-group>
    </form>
  </ng-container>
</ng-container>

<ng-template #staticMode>
  <div class="fw-semibold">{{ getText( 'getting_free_storage' ) }}</div>

  <ul class="mbs-storage-account_options-list">
    <li>
      <i class="fa fa-check-circle mbs-storage-account_check-icon"></i>
      <span>{{ getText( 'free_trial' ) }}</span>
    </li>

    <li class="mt-2">
      <i class="fa fa-check-circle mbs-storage-account_check-icon"></i>
      <span>{{ getText( 'payment_after_trial' ) }}</span>

      <ng-container *ngIf="mode === backupMode.Wasabi && 'HelpMarketing' | can: 'read'">
        <a href="/AP/Help/billing-storage/storage-providers/msp360-storage"
           target="_blank"> {{ 'shared:buttons.learnMore' | i18next }}</a>
      </ng-container>
    </li>
  </ul>

  <div> {{ 'wizards:onboarding.addYourAccount.' + (viewMode === onboardingView.Computers ? 'computersMode' : 'appsMode') | i18next }} </div>
  <div> {{ 'wizards:onboarding.following_options' | i18next }} </div>

  <mbs-storage-icons class="d-block mt-4"
                     [storages]="storageList"
                     [alignClasses]="'justify-content-between align-items-center'"></mbs-storage-icons>
</ng-template>
